/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const VerifiedIcon: React.SFC = () => {
    return (
        <svg width="121" height="54" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <path d="M2 0h119v54H0V2a2 2 0 0 1 2-2z" fill="#F4F7FA" />
                <text fontFamily="AvenirNext-DemiBold, Avenir Next" fontSize="12" fontWeight="500" letterSpacing="2" fill="#555A77">
                    <tspan x="40" y="28">SECURITY </tspan>
                    <tspan x="40" y="40">VERIFIED</tspan>
                </text>
                <g transform="translate(10 12)">
                    <circle stroke="#555B76" strokeWidth="2" cx="11.5" cy="18.5" r="10.5" />
                    <path d="M6 8V5.6C6 2.507 8.462 0 11.5 0S17 2.507 17 5.6V8" stroke="#555A77" strokeWidth="2" strokeLinecap="square" />
                    <g transform="rotate(-180 7 11.5)">
                        <ellipse fill="#555A77" cx="2.5" cy="5.6" rx="2.5" ry="2.4" />
                        <path d="M2.5 0c.46 0 .833.373.833.833V4.8H1.667V.833C1.667.373 2.04 0 2.5 0z" fill="#555B76" />
                    </g>
                </g>
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Verified/Verified.tsx